/* eslint-disable camelcase */
import { GroupMessageEmailStatusSearchFilter } from 'src/modules/groupMessageEmail/models/groupMessageEmailStatusSearchFilter';
import { EmailResponse } from 'src/modules/groupMessageEmail/models/emailResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'Email';

export const getEmailsByCircularId = (searchFilter: GroupMessageEmailStatusSearchFilter) => {
  // eslint-disable-next-line camelcase
  const { circular_id, ...rest } = searchFilter;
  const endpoint = `${controller}/?${setPagingParams({ ...rest, sortDir: rest.sortDir as string })}&circular_id=${circular_id}`;
  return AxiosInstance.get<PagedResult<EmailResponse>>(endpoint);
};

export type InvoiceMailStatusFilter = {
  missionId: number;
  sendingType: 'Main' | 'Reminder1' | 'Reminder2';
  pageIndex: number;
  pageSize: number;
  sortCol: string;
  sortDir: string;
  filter?: string;
};

const mapSendingTypeToCircularCustom9 = (sendingType: InvoiceMailStatusFilter['sendingType']) => {
  switch (sendingType) {
    case 'Reminder1':
      return 'GROUPMAIL|InvoiceReminder';
    case 'Reminder2':
      return 'GROUPMAIL|InvoiceReminder2';
    default:
      return 'GROUPMAIL|Invoice';
  }
};

export const getEmailsByMission = (searchFilter: InvoiceMailStatusFilter) => {
  const { missionId, sendingType, ...rest } = searchFilter;
  const circularCustom9 = mapSendingTypeToCircularCustom9(sendingType);
  const endpoint = `${controller}/?${setPagingParams({ ...rest })}&custom5=${encodeURIComponent(missionId)}&circularCustom9=${encodeURIComponent(
    circularCustom9,
  )}`;
  return AxiosInstance.get<PagedResult<EmailResponse>>(endpoint);
};

export type InvoiceMailStatsResponse = {
  total: number;
  sent: number;
  opened: number;
  error: number;
  firstCreatedAt: string | null;
  lastSentAt: string | null;
};

export const getInvoiceMailStatsByMission = (missionId: number, sendingType: InvoiceMailStatusFilter['sendingType']) => {
  const endpoint = `${controller}/StatsByMission?missionId=${missionId}&sendingType=${encodeURIComponent(sendingType)}`;
  return AxiosInstance.get<InvoiceMailStatsResponse>(endpoint);
};

export const getEmailsByRecipient = (recipientEmail: string, pageSize = 5) => {
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex: 0,
    pageSize,
    sortCol: 'mail_id',
    sortDir: 'desc',
  })}&sent=true&custom1=${encodeURIComponent(recipientEmail)}`;
  return AxiosInstance.get<PagedResult<EmailResponse>>(endpoint);
};

export const getEmailSubscription = (email: string) => {
  const endpoint = `${controller}/OptOut/?email=${email}`;

  return AxiosInstance.get(endpoint);
};

export const getUpdateSubscription = (email: string, activateSubscription: boolean) => {
  const endpoint = `${controller}/OptOut?email=${email}&optOut=${activateSubscription}`;

  return AxiosInstance.put(endpoint);
};
